import * as React from 'react';
import Input from '../../Elements/Input';
import ToggleSwitch, { ToggleStyle } from '../../shared/ToggleSwitch';
import { Modal, Form, Row, Col } from 'react-bootstrap';
import { Permission, UserInfo, RoleInfo } from '../../Login/common/defaults';

interface IUserFormStateProps {
	user: UserInfo;
	roles: RoleInfo[];
	permissions: Permission[];
	errors?: [];
	showModal: boolean;
}

interface IUserFormActions {
	onSave: (event: any) => void;
	onChange: (event: any) => void;
	handleClose: () => void;
	onToggleChange: (toggleIndex, on, label) => void;
}

export interface IUserFormProps extends IUserFormStateProps, IUserFormActions { }

const UserForm: React.FC<IUserFormProps> = ({
	user,
	roles,
	permissions,
	onSave,
	onChange,
	errors,
	handleClose,
	showModal,
	onToggleChange
}) => {
	const activeToggle = (
		<ToggleSwitch
			on={user.active}
			label="Active"
			toggle={ToggleStyle.AllowedToEdit}
			key={0}
			toggleIndex={0}
			enabled={true}
			onChange={onToggleChange}
		/>
	);

	const roleToggles = roles.map((role) => (
		<Form.Row key={"role" + role.id}>
			<ToggleSwitch
				on={
					user && user.userRoles && user.userRoles.find((roleLink) => roleLink.roleId === role.id) ? (
						true
					) : (
						false
					)
				}
				label={role.name}
				toggle={ToggleStyle.AllowedToEdit}
				key={role.id}
				toggleIndex={role.id}
				enabled={true}
				onChange={onToggleChange}
				groupName="roles"
			/>
		</Form.Row>
	));

	const permissionToggles = permissions.map((p) => {
		const hasUserPermission = user && user.userPermissions && (user.userPermissions && user.userPermissions.find((up) => up.permissionId === p.id)) ? true : false;
		const hasRolePermission = user && user.userRoles && (user.userRoles.find(ur => ur.role.rolePermissions.find((rp) => rp.permissionId === p.id))) ? true : false;
		const lock = hasRolePermission ? "<i class='fas fa-lock'></i>  " : "";
		return (
			<Form.Row key={"permission" + p.id}>
				<ToggleSwitch
					on={
						user && (hasUserPermission || hasRolePermission) ? (
							true
						) : (
							false
						)
					}
					label={lock + p.name}
					toggle={ToggleStyle.AllowedToEdit}
					key={p.id}
					toggleIndex={p.id}
					enabled={!hasRolePermission}
					onChange={onToggleChange}
					groupName="permissions"
				/>
			</Form.Row>)
	}
	);
	const hasUserId = user.id !== undefined && user.id !== -1;

	return (
		<Modal dialogClassName=".modal-fullscreen" show={showModal} onHide={handleClose} size='lg'>
			<Modal.Header>
				<Modal.Title>
					<div style={{ fontSize: '1rem' }}>
						{activeToggle}
					</div>
					<div>{hasUserId ? 'Edit' : 'Add'} User</div>
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form onSubmit={onSave}>
					<Input
						title="First Name"
						name="firstName"
						label="First Name"
						type="text"
						value={user.firstName ? user.firstName : undefined}
						onChange={onChange}
						placeholder={'First Name'}
					/>
					<Input
						title="Last Name"
						name="lastName"
						label="Last Name"
						type="text"
						value={user.lastName ? user.lastName : undefined}
						onChange={onChange}
						placeholder={'Last Name'}
					/>
					<Input
						title="Username"
						name="username"
						label="Username"
						type="text"
						value={user.username ? user.username : undefined}
						onChange={onChange}
						placeholder={'Username'}
					/>
					<Input
						title="email"
						name="email"
						label="email"
						type="text"
						value={user.email ? user.email : undefined}
						onChange={onChange}
						placeholder={'email'}
					/>
					<Form.Group controlId="buttons">
						<button className="btn btn-primary" type="submit">
							Save
						</button>
						<button className="btn btn-secondary float-right" onClick={handleClose}>
							Cancel
						</button>
					</Form.Group>
					<Row>
						<Col>
							<h4>Roles</h4>
							{roleToggles}
						</Col>
						<Col>
							<h4>Permissions</h4>
							{permissionToggles}
						</Col>
					</Row>

				</Form>
			</Modal.Body>
		</Modal>
	);
};

export default UserForm;
